import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const RoleQuerySchema = PaginationRequestSchema.extend({
  name: z.string().optional(),
  guardSlug: z.string().optional(),
  status: z.string().optional(),
  platformAccess: z.string().optional(),
  createdFrom: z.string().optional(),
  createdTo: z.string().optional(),
});
export type RoleQueryDTO = z.infer<typeof RoleQuerySchema>;

// Query schema para permisos
export const PermissionQuerySchema = PaginationRequestSchema.extend({
  roleId: z.string().optional(),
  name: z.string().optional(),
  guardSlug: z.string().optional(),
  status: z.string().optional(),
  nameSection: z.string().optional(),
  nameHead: z.string().optional(),
});
export type PermissionQueryDTO = z.infer<typeof PermissionQuerySchema>;

// Permission Response
export const PermissionResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  guardSlug: z.string(),
  description: z.string(),
  nameSection: z.string().nullable(),
  nameHead: z.string().nullable(),
  order: z.number(),
  status: z.string(),
});

export type PermissionResponseDTO = z.infer<typeof PermissionResponseSchema>;

// Paginated Permissions Response
export const PermissionsPaginatedResponseSchema = PaginationResponseSchema(
  PermissionResponseSchema
);
export type PermissionsPaginatedResponseDTO = z.infer<
  typeof PermissionsPaginatedResponseSchema
>;

// Role Request
export const CreateRoleRequestSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  guardSlug: z.string().min(1, "El guard slug es requerido"),
  description: z.string().optional(),
  status: z.enum(["active", "inactive", "deleted"]).default("active"),
  platformAccess: z.enum(["web", "mobile", "both"]).default("both"),
});

export const UpdateRoleRequestSchema = CreateRoleRequestSchema.partial();

export type CreateRoleRequestDTO = z.infer<typeof CreateRoleRequestSchema>;
export type UpdateRoleRequestDTO = z.infer<typeof UpdateRoleRequestSchema>;

// Role Response
export const RoleResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  guardSlug: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  platformAccess: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type RoleResponseDTO = z.infer<typeof RoleResponseSchema>;

// Paginated Roles Response
export const RolesPaginatedResponseSchema = PaginationResponseSchema(
  RoleResponseSchema
);
export type RolesPaginatedResponseDTO = z.infer<typeof RolesPaginatedResponseSchema>;

// Update Role Permissions Request
export const UpdateRolePermissionsRequestSchema = z.object({
  permissionIds: z.array(z.string().min(1, "El ID del permiso es requerido")).min(1, "Debe haber al menos un permiso"),
});

export type UpdateRolePermissionsRequestDTO = z.infer<typeof UpdateRolePermissionsRequestSchema>;

// Update Role Permissions Response
export const UpdateRolePermissionsResponseSchema = z.object({
  message: z.string(),
});

export type UpdateRolePermissionsResponseDTO = z.infer<typeof UpdateRolePermissionsResponseSchema>;
